import * as React from 'react';
import { useState, useEffect } from 'react';
import { UserService } from '@enginuity-common/services/userService';
import { SpinnerOverlay } from '@enginuity-apps-ui-components/atoms/spinner/spinner';
import GenericErrorMessage from '../../components/misc/generic-error-message';
import { getRawUrlParameter } from '@enginuity-common/utils/url';
import ChangeComplete from '../../components/misc/change-complete';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';

type IVerifyEmailChangeProps = {
  fromUri: string;
};

export default function VerifyEmailChange({fromUri}: IVerifyEmailChangeProps) {
  const [genericError, setGenericError] = useState<string | undefined>();
  const [showSpinner, setShowSpinner] = useState(true);
  const [showEmailChangeConfirmation, setShowEmailChangeConfirmation] = useState<boolean>(false);

  const usersService = new UserService({
    baseUrl: window.spConfig.usersBaseUrl
  });



  useEffect(() => {
    const code = getRawUrlParameter('c');
    usersService
      .verifyEmailChange({ code: code })
      .then(response => {
        setShowSpinner(false);
        if (response.status === 400) {
          return Promise.resolve(null);
        } else if (!response.ok) {
          throw new Error('An error occurred while attempting to verify the email change.');
        }
        return response.json();
      })
      .then(() => {
        setShowEmailChangeConfirmation(true);
      })
      .catch(error => {
        console.log(error);
        setShowSpinner(false);
        setGenericError(error);
      });
  }, []);

  if (genericError) {
    return <GenericErrorMessage errorMsg={genericError} tryAgainLink="/manage" fromUri={fromUri}></GenericErrorMessage>
  }


  return (<>
    {showEmailChangeConfirmation && (
      <ChangeComplete>
        <div className="row spacer-32">
          <div className="col-12">
            <h3>Your email change is complete.</h3>
          </div>
        </div>
        <div className="row spacer-48">
          <div className="col-12">
            <Button buttonType="link" href="/manage" className="cmp-button--secondary">Back to my account</Button>
          </div>
        </div>
      </ChangeComplete>
    )}
    <SpinnerOverlay active={showSpinner} />
  </>
  );

}
